import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController, ToastController, App } from 'ionic-angular';
import { Clipboard } from '@ionic-native/clipboard';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';
import { WithdrawalpointPage } from '../withdrawalpoint/withdrawalpoint';

/**
 * Generated class for the WithdrawalpointlistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-withdrawalpointlist',
  templateUrl: 'withdrawalpointlist.html',
})
export class WithdrawalpointlistPage {
    list: string = 'completed';
    segment: string;

	loginId: string;
	email: string;
    api_key: string;
    version: string;
	wallet_address: string;
    coin: string = '';
    office_address: string;
	address: string;
	rate: any = [];

	completed_list: any = [];
	pending_list: any = [];
    // params: any[] = [];
    // count: number = 0;
    // max_length: number = 0;
    
	coin_unit: string;
	unit: string;
	cash_unit: string;
    
    balance_coin: any = [];
    balance_usdt: string;

	imagePath: string;
	qrData = null;
  	createdCode = null;
	scannedCode = null;

	texts: any = [];
    language : string;

    isButton : boolean = true;

	constructor(
		public navCtrl: NavController,
        public navParams: NavParams,
		public alertCtrl: AlertController,
		public modalCtrl: ModalController,
		public toastCtrl: ToastController,
		// private barcodeScanner: BarcodeScanner,
		// private camera: Camera,
        private clipboard: Clipboard,
        private http: HttpService,
		public app: App
	) {
        this.segment = navParams.get("segment");
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "withdrawalcashlist");
		this.loginId = localStorage.getItem("loginId");
		this.email = localStorage.getItem("email");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		this.coin_unit = localStorage.getItem("coin_unit");
		this.unit = localStorage.getItem("unit");
		this.cash_unit = localStorage.getItem("cash_unit");

        this._get_texts();

        if (this.segment == 'pending') {
            this.list = this.segment;
        } else {
            this.list = 'completed';
        }

		this._init();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).withdrawalcashlist;
	}

    _cancel(idx){
		let alert = this.alertCtrl.create({
			message: this.texts.alertM_cancel,
			buttons: [
				{
					text: this.texts.no_btn
				},
				{
					text: this.texts.yes_btn,
					handler: () => {
						let body = JSON.stringify({
                            api: this.api_key,
                            language: this.language,
                            version: this.version,
							idx: idx
						});
						this.http.post("withdraw/point/index/delete", body).then((res: any) => {
							if(res.result === "OK"){
                                this._init();

							} else if(res.result ==="RELOAD"){
								let alert = this.alertCtrl.create({
									message: res.message,
									buttons: ['OK']
								});
								alert.present();
								this._init();

							} else {
								let alert = this.alertCtrl.create({
									message: res.message,
									buttons: ['OK']
								});
								alert.present();
							}
						},(err)=>{	
							//// HTTP 에러인 경우
							let alert = this.alertCtrl.create({
								message: err,
								buttons: ['OK']
							});
							alert.present();
						
						});
					}
				}
			]
		});
		alert.present();
    }

	_init() {		
		this.completed_list = [];
		this.pending_list = [];
		
        let url = "withdraw/point/index/list";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
			// 	this.office_address = res.address;
                // this.rate = res.rate;
                this.balance_coin = res.balance;
                // this.balance_usdt = res.balance.usdt;

                if (res.list != undefined) {   
                    if(res.list.completed != undefined) {
                        this.completed_list = res.list.completed;

                    }
                    if(res.list.pending != undefined) {
                        this.pending_list = res.list.pending;
                        
                    }
                }
				
				// if(res.list != undefined) {
				// 	this.list = res.list;
				// 	this.max_length = res.list.length;
				// 	this.params = [];
				// 	this.count = 0;
				// 	for (var i = 0; i < 9; i++) {
				// 		if(this.max_length <= this.count) break;
				// 		this.params.push(this.items[this.count]);
				// 		this.count++;
				// 	}
				// }
			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                // this.navCtrl.pop();

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				this.navCtrl.pop();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		},(err)=>{
			let alert = this.alertCtrl.create({
				message: err.message,
				buttons: ['OK']
			});
			alert.present();
		});
	}

	// _doInfinite(infiniteScroll) {
    //     setTimeout(() => {    
    //         for (var i = 0; i < 9; i++) {
    //             if(this.max_length <= this.count) break;
    //             this.params.push(this.items[this.count]);                
    //             this.count++;
    //         } 

    //         infiniteScroll.complete();
    //     }, 500);
	// }

	_copy(event) {
		this.clipboard.copy(event);
		let alert = this.alertCtrl.create({
        title: "Copy",
        message: event, 
		buttons: ['OK']
		});
		alert.present();
	}

    _withdrawal() {
        // let alert = this.alertCtrl.create({
        //     message: this.texts.alertM_ready,
        //     buttons: ['OK']
        // });
        // alert.present();

        this.navCtrl.push(WithdrawalpointPage, {from : 'list'});
    }
}



// WEBPACK FOOTER //
// ./src/pages/withdrawalpointlist/withdrawalpointlist.ts